










import Vue from 'vue';
import NavigationHeader from '@/components/navigation/NavigationHeader.vue';
import NavigationFooter from '@/components/navigation/NavigationFooter.vue';
import LoadDecklistModal from '@/components/modals/LoadDecklistModal.vue';
import ImportDecklistModal from '@/components/modals/ImportDecklistModal.vue';
import CardInfoModal from '@/components/modals/CardInfoModal.vue';
import { Component } from 'vue-property-decorator';
import { ROOT, SEARCH } from '@/store/actions.ts';

@Component({
  components: {
    NavigationHeader,
    LoadDecklistModal,
    ImportDecklistModal,
    CardInfoModal,
  },
})
export default class App extends Vue {
  private mounted() {
    this.$store.dispatch(ROOT.INITIALIZE_SETS);
    this.$store.dispatch(SEARCH.REQUEST);
  }
}
